module.exports = __webpack_public_path__ + "static/media/2DGACM6.c03951bf.jpg";